import React from 'react';

import axios from 'axios';
import _ from 'lodash';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';

import TableOption from './Option';

import Pagination from '../../../Components/common/NewPagination/Pagination';
import { API_URLS, APPLICATION_HEADERS } from '../../../models/headers';
import { reoderBrokerOptions } from '../../../store/actions/Actions';

const SelectedOptionsTable = ({ page, setPage, pageSize, setPageSize, optionData, setApiData }) => {
  const dispatch = useDispatch();
  const { surveyId } = useParams();

  optionData.optionProviderRequestList = optionData?.optionProviderRequestList?.filter(
    // eslint-disable-next-line array-callback-return
    (item) => !item.deleted,
  );

  const currentSurvey = {
    options: _.orderBy(optionData?.optionProviderRequestList, 'optionOrder', 'asc'),
  };

  const shortlistedOptions = optionData?.ShortlistedOptions;

  // const surveyID = currentSurvey?.id;

  // const { setSnackBars } = React.useContext(SnackBarContext);

  const totalPages = Math.ceil(optionData?.optionProviderRequestList?.length / pageSize);
  const START_IDX = page * pageSize - pageSize;
  const END_IDX =
    totalPages === page ? optionData?.optionProviderRequestList?.length : page * pageSize;

  const dragendHandler = async (params) => {
    if (!params.destination || params.destination.index === params.source.index) return;

    const draggableIndex = params.source.index + START_IDX;
    const destinationIndex = params.destination.index + START_IDX;

    const draggableItem = currentSurvey?.options[draggableIndex];

    const op = currentSurvey.options.splice(
      destinationIndex,
      0,
      currentSurvey.options.splice(draggableIndex, 1)[0],
    );

    let order = 0;
    const currentOptions = currentSurvey?.options?.slice(START_IDX, END_IDX);

    if (currentOptions?.length) {
      order = START_IDX + 1;
    }

    const updatedOptionsWithNewOrder = [];

    const newOrderForOptions = currentOptions?.map((option) => {
      let result = {};

      if (draggableItem.id === option.id) {
        result = {
          id: option.id,
          optionOrder: destinationIndex + 1,
        };

        updatedOptionsWithNewOrder.push({ ...option, optionOrder: destinationIndex + 1 });

        order += 1;

        return result;
      }

      result = {
        id: option.id,
        optionOrder: order,
      };

      updatedOptionsWithNewOrder.push({ ...option, optionOrder: order });

      order += 1;

      return result;
    });

    const updatedOptions = { list: newOrderForOptions };

    currentSurvey.options = updatedOptionsWithNewOrder;

    // dispatch(reoderBrokerOptions(updatedOptionsWithNewOrder));

    try {
      const url = `${API_URLS.updateBubbleOptionURL}`;

      await axios.put(url, updatedOptions, {
        headers: APPLICATION_HEADERS.dealHeaders,
      });
    } catch (e) {
      // setSnackBars(FAIL_SNACKBAR_OBJECT);
    }
  };

  return (
    <>
      <Table className="optionsTable">
        <THead>
          <ContentBlock>
            <HeaderBlock width="5%"></HeaderBlock>
            <HeaderBlock width="10%">Show on Client Deliverable</HeaderBlock>
            <HeaderBlock width="5%" align="right">
              S.No
            </HeaderBlock>
            <HeaderBlock width="15%">Provider Name</HeaderBlock>
            <HeaderBlock width="35%">Address</HeaderBlock>
            <HeaderBlock width="30%">Notes</HeaderBlock>
            <HeaderBlock width="2%"></HeaderBlock>
          </ContentBlock>
        </THead>

        <DragDropContext onDragEnd={dragendHandler}>
          <Droppable droppableId="droppale-1">
            {(provided, _) => (
              <TBody ref={provided.innerRef} {...provided.droppableProps}>
                {currentSurvey?.options?.length === 0 && (
                  <ContentBlock>
                    <BodyBlock align="center" colSpan={8}>
                      Not found
                    </BodyBlock>
                  </ContentBlock>
                )}
                {currentSurvey?.options?.slice(START_IDX, END_IDX).map((option, idx) => (
                  <Draggable
                    key={`${option.id}-${idx}-${option.optionOrder}-${option.providerId}`}
                    draggableId={'draggable1-' + option.id}
                    index={idx}
                  >
                    {(provided) => (
                      <TableOption
                        option={option}
                        surveyID={surveyId}
                        key={`${option.id}-${idx}-${option.optionOrder}-${option.providerId}`}
                        shortlistedOptions={shortlistedOptions}
                        provided={provided}
                        // setStackOfCopiedOptions={setStackOfCopiedOptions}
                      />
                    )}
                  </Draggable>
                ))}
              </TBody>
            )}
          </Droppable>
        </DragDropContext>
      </Table>
      {currentSurvey?.options?.length > 10 && (
        <Pagination
          page={page}
          toPage={setPage}
          pageSize={pageSize}
          onPageSize={setPageSize}
          totalCount={totalPages}
        />
      )}
    </>
  );
};

const Table = styled.table`
  border-spacing: 0;
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border: 0;
`;
const THead = styled.thead`
  height: 56px;
  background: #e6eaea;
  padding: 12px;
`;
const TBody = styled.tbody`
  background: #ffffff;
  padding: 12px;
`;

export const ContentBlock = styled.tr`
  box-sizing: border-box;
  display: ${({ display }) => display};
  flex-direction: ${({ flexDirection }) => flexDirection};

  &:nth-child(even) {
    background-color: #f5f7f7;
  }
`;
const HeaderBlock = styled.th`
  width: ${({ width }) => width};
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #1a1a1a;
  padding: ${({ padding }) => padding};
  padding-left: 10px;
  text-align: ${({ align }) => align};
`;

export const BodyBlock = styled.td`
  width: ${({ width }) => width};
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  color: #1a1a1a;
  text-align: ${({ align }) => align};
  word-wrap: break-word;
  padding: 15px 20px 15px 10px;
  cursor: ${({ cursorType }) => cursorType};
`;

export default SelectedOptionsTable;
